import { render, staticRenderFns } from "./PlaceCardv2.vue?vue&type=template&id=5731f2a2&scoped=true"
import script from "./PlaceCardv2.vue?vue&type=script&lang=js"
export * from "./PlaceCardv2.vue?vue&type=script&lang=js"
import style0 from "./PlaceCardv2.vue?vue&type=style&index=0&id=5731f2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731f2a2",
  null
  
)

export default component.exports